class Drawer extends HTMLElement {
  constructor() {
    super();

    // Properties are initialized here because the build system does not support class-level property declarations.
    this.drawer = null;
    this.closeButtons = null;
    this.drawerType = null;
    this.activeClass = null;

  }

  connectedCallback() {

    // Query DOM elements after component is connected
    this.drawer = this.querySelector('[data-drawer-inner]');
    this.overlay = this.querySelector('.drawer__overlay');

    if (!this.drawer) return;

    // Set event listeners
    this.onBodyClick = (event) => this.handleBodyClick(event);
    this.onEscapeKey = (event) => this.handleEscapeKey(event);

    // Get drawer target from data attribute
    this.drawerType = this.dataset.drawerTarget || 'default';
    this.activeClass = 'drawer--open';

    // Set initial ARIA state (drawer starts closed)
    this.setAttribute('aria-hidden', 'true');

    // Bind close buttons
    this.closeButtons = this.querySelectorAll('[data-drawer-close]');
    this.closeButtons.forEach(btn => {
      btn.addEventListener('click', () => this.close());
    });

    // Add overlay click listener
    this.overlay?.addEventListener('click', () => this.close());
  }

  disconnectedCallback() {
    // Clean up event listeners
    document.body.removeEventListener('click', this.onBodyClick);
    document.removeEventListener('keyup', this.onEscapeKey);
  }

  open() {

    // Add active class to drawer element itself
    this.classList.add(this.activeClass);
    // Set ARIA state to indicate drawer is open
    this.setAttribute('aria-hidden', 'false');

    // Focus the drawer and trap focus
    this.drawer?.focus();

    // Trap focus if function is available
    if (typeof trapFocus === 'function') {
      trapFocus(this.drawer);
    }

    // Add body click listener to close on outside click with a small delay
    setTimeout(() => {
      document.body.addEventListener('click', this.onBodyClick);
    }, 100);

    // Add escape key listener to document when drawer opens
    document.addEventListener('keyup', this.onEscapeKey);
  }

  close() {
    // Remove active class from drawer element itself
    this.classList.remove(this.activeClass);
    // Set ARIA state to indicate drawer is closed
    this.setAttribute('aria-hidden', 'true');
    // Remove body click listener
    document.body.removeEventListener('click', this.onBodyClick);
    // Remove escape key listener
    document.removeEventListener('keyup', this.onEscapeKey);
    // Remove focus trap if function is available
    if (typeof removeTrapFocus === 'function') {
      removeTrapFocus();
    }
  }

  handleBodyClick(event) {
    const target = event.target;
    // Close if clicked outside the drawer
    if (target !== this.drawer && !target.closest('custom-drawer')) {
      this.close();
    }
  }

  handleEscapeKey(event) {
    if (event.key === 'Escape' && this.classList.contains(this.activeClass)) {
      event.preventDefault();
      event.stopPropagation();
      this.close();
    }
  }
}

if (!customElements.get('custom-drawer')) {
  customElements.define('custom-drawer', Drawer);
}
